// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1O2yY","head":"ProcedureTableInfo_head__3_wRi"};